import axios from '@/utils/axios';

const getConfig = async () => {

    try {

        const {
            data: {
                resumeApplicationEnabled
            }
        } = await axios.get(`${process.env.BASE_URL}api/Application/DisplayResumeApplication`);
        return { resumeApplicationEnabled };

    } catch (error) {

        throw error;

    };

};

export default {
    getConfig,
};

export {
    getConfig,
};